import { createSelector } from 'reselect'
import { getCurrentModalSelect } from 'modules/modal/selectors'

const hasModalSelect = createSelector(
  getCurrentModalSelect,
  (modalId) => !!modalId
)

export default hasModalSelect
